import React from "react";
import WXPayComponent from "../components/WXPay";

const WXPay: React.FC = () => {
  return (
    <div className="wx-pay-root">
      <div className="title-main title-root" style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
        <h3>WXPay Summary</h3>
      </div>
      <WXPayComponent />
    </div>
  );
};

export default WXPay;
